/* eslint-disable strict */
(function () {
    'use strict';

    angular.module('legitimationUpload')

        .controller('UploadCtrl', ['$scope', '$rootScope', '$http', '$state', '$q', '$sce', '$injector', 'userService', 'dateTimeFactory', 'fallbackFactory', function UploadController($scope, $rootScope, $http, $state, $q, $sce, $injector, userService, dateTimeFactory, fallbackFactory) {

            // get global config
            var config = $injector.get('config');

            $scope.userdata = {};

            $scope.years = dateTimeFactory.getYearRange();
            $scope.months = [
                { val: '01', label: 'Januar'},
                { val: '02', label: 'Februar'},
                { val: '03', label: 'März'},
                { val: '04', label: 'April'},
                { val: '05', label: 'Mai'},
                { val: '06', label: 'Juni'},
                { val: '07', label: 'Juli'},
                { val: '08', label: 'August'},
                { val: '09', label: 'September'},
                { val: '10', label: 'Oktober'},
                { val: '11', label: 'November'},
                { val: '12', label: 'Dezember'},
            ];

            $scope.days = [];
            for (var i = 1; 31 >= i; i++) {
                $scope.days.push( 10 > i ? '0' + i.toString() : i.toString());
            }

            $scope.logicalDate = dateTimeFactory.getLocaleDate();

            function getBirthdate (formData) {

                var ret = '';

                var day = formData.dateofbirthday || '';
                var month = formData.dateofbirthmonth || '';
                var year = formData.dateofbirthyear || '';

                if ('' !== day && '' !== month && '' !== year) {
                    ret = day + '/' + month + '/' + year;
                }

                return ret;

            }

            function checkUploadFile () {

                var ret = {
                    OK: true,
                    errorMessage: '',
                };
                var allowedExtensions = ['JPE', 'JPG', 'JPEG', 'PNG', 'GIF', 'TIFF', 'TIF', 'PDF'];
                var maxFilesize = 4000000;


                var files = document.getElementById('uploadfile').files;

                if (1 > files.length) {

                    ret.OK = false;
                    ret.errorMessage = 'Wähl bitte zuerst eine Datei aus.';

                } else {

                    var file = files[0];
                    var fileName = file.name;

                    // get file extension
                    var idx = fileName.lastIndexOf('.');
                    var fileExtension = ((1 > idx) ? '' : fileName.substr(idx + 1)).toUpperCase();

                    if ( 0 > allowedExtensions.indexOf(fileExtension) ) {
                        ret.OK = false;
                        ret.errorMessage = 'Die Datei hat leider keines der erlaubten Formate!';
                    }

                    var fileSize = file.size;
                    if ( maxFilesize < fileSize) {
                        ret.OK = false;
                        ret.errorMessage = 'Die Datei ist zu gross.\nWähl bitte eine Datei die kleiner als 4 Megabyte ist.';
                    }

                }

                return ret;

            }

            // check if the user is logged in
            userService.checkLoginStatus().then(function () {
                console.log('Logged in.');
                // get userdata
                userService.getData(config.APIURL.USERINFO).then(function (userdata) {
                    if (userService.isElegible()) {
                        $scope.userdata = userdata;
                        $('.simple-promo-teaser').css('display', 'none');
                        $('#icon-box').css('display', 'block');
                        $state.go('upload');
                    } else {
                        console.log('user not elegible');
                        fallbackFactory.logoutAndRedirect(GLOBALURLS.PAGEURL.FAILTARIFF);
                    }
                }, function () {
                    console.log('retrieve data failed');
                    fallbackFactory.logoutAndRedirect(GLOBALURLS.PAGEURL.FAIL);
                });
            }, function () {
                console.log('Not logged in.');
                $state.go('login');
            });

            $scope.changeDate = function(formData) {

                formData.completeDate = getBirthdate(formData);

            };

            $scope.submit = function(formData) {

                userService.checkLoginStatus().then(function (failData) {

                    if ('object' !== typeof failData || 409 === failData.code) {
                        console.log('session abgelaufen');
                        window.location.href = GLOBALURLS.PAGEURL.FAIL;
                    } else {

                        $scope.uploadForm.$submitted = true;

                        $scope.uploadFileInvalid = false;

                        // is birthday filled?
                        var birthdate = getBirthdate(formData);

                        // is uploaded file ok?
                        var okFile = checkUploadFile();

                        if ('' !== birthdate && true === okFile.OK) {
                            // form can be send
                            $('#uploadForm').submit();
                        } else {
                            if (false === okFile.OK) {
                                $scope.uploadFileInvalid = true;
                                $scope.fileUploadErrorCode = okFile.errorMessage;
                            }
                        }


                    };
                }, function () {
                    console.log('Not logged in.');
                    $state.go('login');
                });

            };

            $scope.logout = function() {
            // logout
                $.get(GLOBALURLS.APIURL.LOGOUT);
                $state.go('login');
            };

        }])

        .controller('LoginCtrl', ['$scope', '$rootScope', '$http', '$state', 'userService', '$injector', 'fallbackFactory', 'stringHelper', function LoginController($scope, $rootScope, $http, $state, userService, $injector, fallbackFactory, stringHelper) {

            // get global config
            var config = $injector.get('config');

            // Set the default value of inputType
            $scope.inputType = 'password';

            // Hide & show password function
            $scope.hideShowPassword = function () {
                if ('password' === $scope.inputType) {
                    $scope.inputType = 'text';
                } else {
                    $scope.inputType = 'password';
                }
            };

            function translateErrorMessage (errorMessage) {

                /*
                "Bitte geben Sie eine gültige Handy-Nummer ein!"
                „Rufen Sie“ durch „rufe“
                „Ihren Zugang“ durch „Deinen Zugang“
                „Ihr Zugang“ durch „Dein Zugang“
                „Sie haben“ durch „Du hast“
                Sie können
                */
                var ret = errorMessage;

                if ('Bitte geben Sie eine gültige Handy-Nummer ein!' === errorMessage) {
                    return 'Gib bitte eine gültige Handy-Nummer ein!';
                } else {
                    ret = errorMessage.replace('Rufen Sie', 'Ruf')
                        .replace('Ihren Zugang', 'Deinen Zugang')
                        .replace('Ihr Zugang', 'Dein Zugang')
                        .replace('Sie können', 'Du kannst')
                        .replace('Sie haben', 'Du hast');
                }

                return ret;

            }

            // Submit form
            $scope.formLoginSubmitted = false;
            $scope.loginFailed = false;
            $scope.login = function (user) {
                $scope.formLoginSubmitted = true;
                if ($scope.formLogin.$valid) {
                    userService.login(user.msisdn, user.password, '/cc/vf/userinfo/vfplan.ftl').then(function (data) {
                        console.log('Login successful.');
                        // get userdata
                        userService.getData(config.APIURL.USERINFO).then(function () {
                            if (userService.isElegible()) {
                                $state.go('upload');
                            } else {
                                console.log('user not elegible');
                                fallbackFactory.logoutAndRedirect(GLOBALURLS.PAGEURL.FAILTARIFF);
                            }
                        }, function () {
                            console.log('retrieve data failed');
                            fallbackFactory.logoutAndRedirect(GLOBALURLS.PAGEURL.FAIL);
                        });
                    }, function (data) {
                        console.log('Login failed');
                        $scope.loginFailed = true;
                        var errorMessage = stringHelper.decodeHtmlSpecialChar(data.message);
                        if (409 === data.code) {
                            // as all messages from backend come in "sie", we have to change this manually here
                            //errorMessage = 'Bitte gib eine gültige Handy-Nummer ein!';
                            errorMessage = translateErrorMessage(errorMessage);
                        }
                        $scope.errorMessage = errorMessage;
                    });
                }
            };
        }])

        .controller('SmsCodeLoginCtrl', ['$scope', '$rootScope', '$state', 'userService', '$injector', function SmsCodeLoginController($scope, $rootScope, $state, userService, $injector) {

            // get global config
            var config = $injector.get('config');

            $scope.formGetSmsCodeSubmitted = false;
            $scope.getSmsCode = function () {
                $scope.formGetSmsCodeSubmitted = true;
                if ($scope.formGetSmsCode.$valid) {
                    $scope.smsCodeSent = false;
                    $scope.smsCodeSentFailed = false;

                    userService.sendSmsCode($scope.msisdn, config.APIURL.USERINFO).then(function (data) {
                        console.log('SMS-Code successfully sent.');
                        $scope.smsCodeSent = true;
                    }, function (data) {
                        console.log('SMS-Code could not be sent.');
                        $scope.smsCodeSentFailed = true;
                        $scope.errorMessageSmsCode = stringHelper.decodeHtmlSpecialChar(data.message);
                    });
                }
            };

            $scope.formSmsCodeLoginSubmitted = false;
            $scope.smsCodeLogin = function () {
                $scope.formSmsCodeLoginSubmitted = true;
                if ($scope.formSmsCodeLogin.$valid) {
                    $scope.loginWithCodeFailed = false;

                    userService.loginWithCode($scope.msisdn, $scope.smscode, config.APIURL.USERINFO).then(function (data) {
                        if (data.result.code && 201 === data.result.code) {
                        // wrong code
                            console.log('Login failed. Wrong code.');
                            $scope.loginWithCodeFailed = true;
                            $scope.errorMessageSmsCode = 'Der eingegebene Code ist ungültig.';
                        } else {
                            console.log('Login successful.');
                            // get userdata
                            userService.getData(config.APIURL.USERINFO);
                            $state.go('upload');
                        }
                    }, function (data) {
                        console.log(data);
                        console.log('Login failed');
                        $scope.loginWithCodeFailed = true;
                        $scope.errorMessageSmsCode = stringHelper.decodeHtmlSpecialChar(data.message);

                    });
                }
            };
        }]);

}());
